import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import TablePagination from "../../../Components/Molecules/Pagination";
import NoRecords from "../../../Components/Atoms/NoRecord";
import toast from "react-hot-toast";
import { Delete, Edit } from "@mui/icons-material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { CircularProgress } from "@mui/material";
import AvailableStatus from "../../../Components/Atoms/AvailableStatus";
import CustomButton from "../../../Components/Atoms/CustomButton";
import CustomDialog from "../../../Components/Molecules/CustomDialog";
import CreateReminder from "./Form/CreateReminder";
import {
  getCronSettingsListRequest,
  putStatusCronSettingsRequest,
  postCronSettingsResponseClear,
  deleteCronSettingsRequest,
} from "../../../Redux/CronSettings/CronSettingsActions";
import { MODULES, NOTIFY_TYPE, ROLE_BY_PERMISSIONS } from "../../../Constant";
import ConfirmModal from "../../../Components/Molecules/ConfirmModal/Index";
import { hasPermission } from "../../../Utils/getters";

const IndexReminder = () => {
  const dispatch = useDispatch();
  const {
    getCronSettingsListLoading,
    getCronSettingsListResponse,
    postCronSettingsResponse,
    postCronSettingsLoading,
    deleteCronSettingsLoading,
    deleteCronSettingsResponse,
  } = useSelector((state) => state.cronSettingReducer);

  const { getUserResponse } = useSelector((state) => state.user);

  const [page, setPage] = useState(1);
  const searchSchema = {
    filters: {
      search: {
        value: "",
      },
    },
    limit: 10,
    page: page,
    sort: "createdAt:asc",
  };

  const searchFormik = useFormik({
    initialValues: searchSchema,
    onSubmit: (values) => {
      setPage(1);
      return dispatch(getCronSettingsListRequest(values));
    },
  });

  useEffect(() => {
    if (deleteCronSettingsLoading || postCronSettingsLoading) return;
    dispatch(getCronSettingsListRequest({ ...searchFormik.values, page }));
  }, [page, postCronSettingsLoading, deleteCronSettingsLoading]);

  //
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const handleOpen = (data = null) => {
    setOpen(true);
    setData(data);
  };

  useEffect(() => {
    if (postCronSettingsResponse?.success) {
      toast.success(postCronSettingsResponse?.message);
      handleClose();
    } else if (postCronSettingsResponse?.response?.data) {
      toast.error(postCronSettingsResponse?.response?.data?.message);
    }
    dispatch(postCronSettingsResponseClear());
  }, [postCronSettingsResponse]);

  const handleClose = () => {
    setOpen(false);
  };

  const [deleteConfig, setDeleteConfig] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const handleDeleteOpen = () => setDeleteOpen(true);
  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  return (
    <>
      <CustomDialog
        maxWidth="md"
        title={data ? "UPDATE REMINDER" : "CREATE REMINDER"}
        handleClose={() => {
          handleClose();
        }}
        open={open}
      >
        <CreateReminder handleClose={handleClose} data={data} />
      </CustomDialog>

      <CustomDialog
        maxWidth="sm"
        title={`S.NO - ${deleteConfig?.s_no}`}
        handleClose={handleDeleteClose}
        open={deleteOpen}
      >
        <ConfirmModal
          message={"Are you sure you want to delete this record ?"}
          subMessage={
            "This will delete this recird permanently, You cannot undo This Action."
          }
          handleSubmit={() => {
            dispatch(deleteCronSettingsRequest({ id: deleteConfig?._id }));
            handleDeleteClose();
          }}
          handleClose={handleDeleteClose}
        />
      </CustomDialog>

      <div className="d-flex-juscon-flex-end-align-center mb-10">
        {hasPermission(
          [ROLE_BY_PERMISSIONS[MODULES.REMINDERS].CREATE_REMINDERS],
          getUserResponse?.data
        ) && (
          <CustomButton
            label={"New Reminder"}
            size="small"
            action={"NEW"}
            onClick={() => handleOpen()}
          />
        )}
      </div>
      {getCronSettingsListLoading &&
      !getCronSettingsListLoading?.data?.length > 0 ? (
        <div className="d-flex align-items-center justify-content-center">
          <CircularProgress size={25} />
        </div>
      ) : (
        <TablePagination
          showFilter={true}
          showSort={true}
          setPage={setPage}
          page={page}
          initialValues={searchSchema}
          formik={searchFormik}
          action={(values) => dispatch(getCronSettingsListRequest(values))}
          result={getCronSettingsListResponse}
          count={getCronSettingsListResponse?.data?.total_count}
        >
          <div className="tblWrpr">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>NOTIFY TYPE</th>
                    <th>PRIORITY</th>
                    <th>MODE</th>
                    <th>INTERVAL</th>
                    <th>STATUS</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {getCronSettingsListResponse?.data?.length > 0 ? (
                    getCronSettingsListResponse?.data?.map((data, index) => {
                      return (
                        <tr key={data._id}>
                          <td>
                            {searchFormik?.values?.limit * (page - 1) +
                              index +
                              1}
                          </td>
                          <td> {NOTIFY_TYPE[data?.notify_type]}</td>
                          <td>
                            <AvailableStatus
                              customCls={
                                data?.priority === "HIGH"
                                  ? "index-red"
                                  : data?.priority === "MEDIUM"
                                  ? "index-orange-mild"
                                  : "index-green"
                              }
                              status={data?.priority}
                            />
                          </td>
                          <td>
                            <AvailableStatus
                              customCls={
                                data?.mode === "TIME"
                                  ? "index-green"
                                  : "index-orange-mild"
                              }
                              status={data?.mode}
                            />
                          </td>

                          <td>
                            {data?.mode === "TIME"
                              ? `${data?.hours} Hr - ${data?.minutes} Min`
                              : `${data?.days} Day (s)`}
                          </td>
                          <td>
                            <AvailableStatus
                              customCls={
                                data?.status === "ACTIVE"
                                  ? "index-green"
                                  : "index-red"
                              }
                              status={data?.status}
                            />
                          </td>
                          <td>
                            <div className="view">
                              {hasPermission(
                                [
                                  ROLE_BY_PERMISSIONS[MODULES.REMINDERS]
                                    .STATUS_REMINDERS,
                                ],
                                getUserResponse?.data
                              ) && (
                                <button
                                  onClick={() =>
                                    dispatch(
                                      putStatusCronSettingsRequest({
                                        id: data?._id,
                                        status:
                                          data?.status === "ACTIVE"
                                            ? "INACTIVE"
                                            : "ACTIVE",
                                      })
                                    )
                                  }
                                >
                                  {data.status === "ACTIVE" ? (
                                    <RemoveCircleOutlineIcon />
                                  ) : (
                                    <DoneIcon />
                                  )}
                                </button>
                              )}
                              {hasPermission(
                                [
                                  ROLE_BY_PERMISSIONS[MODULES.REMINDERS]
                                    .UPDATE_REMINDERS,
                                ],
                                getUserResponse?.data
                              ) && (
                                <button onClick={() => handleOpen(data)}>
                                  <Edit />
                                </button>
                              )}
                              {hasPermission(
                                [
                                  ROLE_BY_PERMISSIONS[MODULES.REMINDERS]
                                    .DELETE_REMINDERS,
                                ],
                                getUserResponse?.data
                              ) && (
                                <button
                                  onClick={() => {
                                    setDeleteConfig({
                                      ...data,
                                      s_no:
                                        searchFormik?.values?.limit *
                                          (page - 1) +
                                        index +
                                        1,
                                    });
                                    handleDeleteOpen();
                                  }}
                                >
                                  <Delete />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NoRecords />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </TablePagination>
      )}
    </>
  );
};

export default IndexReminder;
